import { ReactNode } from "react"
import { Icon, IconRef } from "./Icon"
import { cn, tv } from "@utils/tw"
import { ButtonGroup } from "./ButtonGroup"

type Props = {
  icon?: IconRef
  title?: ReactNode | string
  description?: ReactNode | string
  actions?: ReactNode
  className?: string
}

export function NonIdealState(props: Props) {
  const styles = createStyles({})
  return (
    <div className={cn(styles.base(), props.className)}>
      <div className={styles.inner()}>
        {props.icon && <Icon name={props.icon} className={styles.icon()} />}
        {props.title && <div className={styles.title()}>{props.title}</div>}
        {props.description && <div className={styles.description()}>{props.description}</div>}
        {props.actions && <ButtonGroup className={styles.actions()}>{props.actions}</ButtonGroup>}
      </div>
    </div>
  )
}

const createStyles = tv({
  base: ["@container"],
  slots: {
    inner: ["p-5 flex flex-col items-start border border-bg-mid rounded-md text-fg"],
    icon: ["size-6 mb-4"],
    title: ["type-ui-l text-center mb-3"],
    description: ["text-fg-secondary type-ui-s"],
    actions: ["flex gap-4 mt-6 w-full @sm:jsutify-end @[300px]:[&>*]:flex-1"],
  },
})
